module.exports = __webpack_public_path__ + "img/daheilan.a19e17ec.png";